import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/api/client';
import type { DashboardKpiResponse } from '@/api/types';
import { kpiRangeForDays } from '@/features/dashboard/kpiRollup';
import { useProjectContext } from '@/project/ProjectContext';

export function useDashboardKpi(days = 30) {
  const { selectedProjectId } = useProjectContext();
  const { from, to } = kpiRangeForDays(days);

  const qs = new URLSearchParams({ from, to });
  if (selectedProjectId) qs.set('project_id', selectedProjectId);

  return useQuery({
    queryKey: ['dashboard', 'kpi', selectedProjectId ?? 'all', from, to],
    queryFn: () => apiFetch<DashboardKpiResponse>(`/api/dashboard/kpi?${qs.toString()}`),
  });
}
